import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import {
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { v4 as uuidv4 } from 'uuid';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import SortableTasks from './SortableTasks';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

/**
 * Moves an item from one list to another list.
 */
const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};
const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  // padding: grid * 2,
  // margin: `0 0 ${grid}px 0`,
  borderRadius: "10px",

  // change background colour if dragging
  background: isDragging ? "#eee" : "transparent",

  // styles we need to apply on draggables
  ...draggableStyle
});
const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "#ccc" : "transparent",
  padding: `0px`,
  width: '100%',
  marginBottom: '20px',
  borderRadius: "10px"
});

function SortableMilestones(props) {
  var newTask = {
    name: '',
    details: '',
    instructions: '',
    assigneeRoles: '',
    userCanComplete: ''
  };
  const [milestones, setMilestones] = useState(props.items);
  const [state, setState] = useState({
    items: milestones.map((item, index) => {
      item.draggableId = index;
      if (item?.tasks?.length > 0) {
        item.tasks.map((task) => {
          task.draggableId = `task_${uuidv4()}`;
          return task;
        });
      } else {
        item.tasks = [];
      }
      return item;
    })
  });

  function onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const sourceIndex = result.source.index;
    const destIndex = result.destination.index;
    if (result.type === "droppableItem") {
      const items = reorder(state.items, sourceIndex, destIndex);

      setState({
        items
      });
    } else if (result.type === "droppableSubItem") {
      const itemSubItemMap = state.items.reduce((acc, item, index) => {
        acc[index] = item.tasks;
        return acc;
      }, {});

      const sourceParentId = parseInt(result.source.droppableId);
      const destParentId = parseInt(result.destination.droppableId);

      const sourceSubItems = itemSubItemMap[sourceParentId];
      const destSubItems = itemSubItemMap[destParentId];

      let newItems = [...state.items];
      newItems = newItems.map((item, index) => {
        item.draggableId = index;
        return item;
      });

      /** In this case subItems are reOrdered inside same Parent */
      if (sourceParentId === destParentId) {
        const reorderedSubItems = reorder(
          sourceSubItems,
          sourceIndex,
          destIndex
        );
        newItems = newItems.map(item => {
          if (item.draggableId === sourceParentId) {
            item.tasks = reorderedSubItems;
          }
          return item;
        });
        setState({
          items: newItems.map((item, index) => {
            item.draggableId = index;
            return item;
          })
        });
      } else {
        let newSourceSubItems = [...sourceSubItems];
        const [draggedItem] = newSourceSubItems.splice(sourceIndex, 1);

        let newDestSubItems = [...destSubItems];
        if (newDestSubItems?.length < 20) {
          newDestSubItems.splice(destIndex, 0, draggedItem);
          newItems = newItems.map(item => {
            if (item.draggableId === sourceParentId) {
              item.tasks = newSourceSubItems;
            } else if (item.draggableId === destParentId) {
              item.tasks = newDestSubItems;
            }
            return item;
          });
          setState({
            items: newItems.map((item, index) => {
              item.draggableId = index;
              return item;
            })
          });
        }
      }
    }
  }

  const [activeTask, setActiveTask] = useState(null);
  const [activeMileStone, setActiveMilestone] = useState(null);

  const selectTask = (task, taskIndex, milestoneIndex) => {
    props.onSelectedItemChange({ task, taskIndex, milestoneIndex });
    setActiveTask(task);
    setActiveMilestone(null);
  };

  useEffect(() => {
    props.onChange(state);
  }, [state]);

  useEffect(() => {
    setMilestones(props.items);
    setState({ items: props.items });
  }, [props.items]);

  const [isEditingMilestoneIndex, setIsEditingMilestoneIndex] = useState(null);

  const addNewMilestone = () => {
    let milestones = [...state.items];
    let newMilestone = {
      name: 'New Milestone',
      tasks: [],
      draggableId: milestones.length

    };
    milestones.push(newMilestone);
    setState({ items: milestones });
    props.onSelectedMilestoneChange(newMilestone, milestones.length - 1);
  };

  const addNewTask = (milestoneIndex) => {
    let milestones = [...state.items];
    let newTask = {
      draggableId: `newTask_${uuidv4()}`,
      name: 'New Task',
      userCanComplete: true
    };
    milestones[milestoneIndex].tasks = [
      ...milestones[milestoneIndex].tasks,
      newTask
    ];
    setState({ items: milestones });
    selectTask(newTask, milestones[milestoneIndex].tasks.length - 1, milestoneIndex);
  };

  return (
    <div style={{ display: "flex", flexDirection: "row", flex: 1, width: "calc(100% + 30px)" }}>
      <div style={{ display: "flex", flexDirection: "column", flex: 2, marginRight: "40px" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable" type="droppableItem">
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                  {...provided.droppableProps}
                >
                  {state.items.map((el, ind) => (
                    <Draggable key={`${el.draggableId}`} id={`${el.draggableId}`} draggableId={`${el.draggableId}`} index={ind}>
                      {(provided, snapshot) => (
                        <div {...provided.dragHandleProps}>
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            )}
                          >
                            <div key={ind}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: activeMileStone?.draggableId === el.draggableId ? '#ccc' : "#eee", padding: "10px", borderRadius: "10px" }} onClick ={()=> {
                                props.onSelectedMilestoneChange(state.items[ind], ind);
                                setActiveTask(null);
                                setActiveMilestone(state.items[ind]);
                              }}>
                                <div {...provided.dragHandleProps} onClick={(e) => e.stopPropagation()}>
                                  <span style={{ color: 'grey' }}><DragIndicatorIcon color="inherit" fontSize="medium" style={{ marginRight: '10px' }} /></span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', flex: 1 }}>
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                    <b style={{ display: 'flex', flex: 2}} onClick ={()=> setIsEditingMilestoneIndex(ind)}>{el.name || '______'}</b>
                                    <b style={{ display: 'flex', flex: 1}} onClick ={()=> setIsEditingMilestoneIndex(ind)}>{`Start Day ${el.startDay || '______'}`}</b>
                                    <b style={{ display: 'flex', flex: 1}} onClick ={()=> setIsEditingMilestoneIndex(ind)}>{`End Day ${el.endDay || '______'}`}</b>
                                    {el.tasks.length >= 20 ? (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id="delete-tooltip-disabled">
                                            <p>Only 20 tasks may be created per milestone</p>
                                          </Tooltip>
                                        }
                                      >
                                        <div style={{ display: 'flex', alignSelf: 'flex-end', flex: 1, justifyContent: 'flex-end' }}>
                                          <button
                                            className="btn btn-outline-primary"
                                            type="button"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              addNewTask(ind);
                                            }}
                                            disabled={el.tasks.length >= 20 ? true : false}
                                          >
                                        + Add Task
                                          </button>
                                        </div>
                                      </OverlayTrigger>
                                    ) : (
                                      <div style={{ display: 'flex', alignSelf: 'flex-end', flex: 1, justifyContent: 'flex-end' }}>
                                        <button
                                          className="btn btn-outline-primary"
                                          type="button"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            addNewTask(ind);
                                          }}
                                          disabled={el.tasks.length >= 20 ? true : false}
                                        >
                                        + Add Task
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <SortableTasks index={ind} tasks={el.tasks} selectTask={selectTask} activeTask={activeTask} assigneeRoles={props.assigneeRoles} />
                            </div>
                          </div>
                        </div>
                      )}
                      {/* {provided.placeholder} */}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
        <button
          className='btn btn-outline-primary'
          style={{ width: '150px', display: 'flex', alignSelf: 'flex-end' }}
          type="button"
          onClick={() => {
            addNewMilestone();
          }}
        >
          + Add Milestone
        </button>
        <br></br>
        <br></br>
      </div>
    </div>
  );
}

export default SortableMilestones;
